import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['content', 'status']
  static values = { url: String }

  connect() {
    this.sequence = (this.sequence || 0) + 1
    this.load(this.urlValue)
  }

  disconnect() {
    this.sequence += 1
    this.request?.abort()
  }

  navigate(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    this.load(event.currentTarget.href)
  }

  filter(event) {
    event.preventDefault()
    const url = new URL(event.target.action, window.location.href)
    url.search = new URLSearchParams(new FormData(event.target)).toString()
    this.load(url.toString())
  }

  retry() { this.load(this.currentUrl || this.urlValue) }

  async load(url) {
    this.request?.abort()
    this.request = new AbortController()
    const sequence = ++this.sequence
    this.currentUrl = url
    this.contentTarget.replaceChildren()
    this.contentTarget.setAttribute('aria-busy', 'true')
    this.statusTarget.textContent = 'Loading fleet preview…'
    this.statusTarget.hidden = false
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', signal: this.request.signal,
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!response.ok || response.redirected) throw new Error('Could not load the fleet preview.')
      const html = await response.text()
      if (sequence !== this.sequence) return
      this.contentTarget.innerHTML = html
      this.statusTarget.hidden = true
    } catch (error) {
      if (sequence !== this.sequence || error.name === 'AbortError') return
      this.statusTarget.textContent = 'Could not load the fleet preview. Use Reload preview to try again.'
    } finally {
      if (sequence === this.sequence) this.contentTarget.removeAttribute('aria-busy')
    }
  }
}
